import { useRef } from 'react';
var MULTIPLY_FACTOR = 3;
var useHorizontalSlider = () => {
  var sliderRef = useRef(null);
  var isPressed = useRef(false);
  var startX = useRef(0);
  var currentX = useRef(0);
  var onMouseDown = evt => {
    isPressed.current = true;
    if (sliderRef.current) {
      startX.current = evt.pageX - sliderRef.current.offsetLeft;
      currentX.current = sliderRef.current.scrollLeft;
    }
  };
  var onMouseMove = evt => {
    if (isPressed.current && sliderRef.current) {
      evt.preventDefault();
      var diff = evt.pageX - sliderRef.current.offsetLeft;
      var delta = (diff - startX.current) * MULTIPLY_FACTOR;
      sliderRef.current.scrollLeft = currentX.current - delta;
    }
  };
  var onMouseUp = () => {
    isPressed.current = false;
  };
  var onMouseLeave = () => {
    isPressed.current = false;
  };
  return {
    onMouseDown,
    onMouseMove,
    onMouseLeave,
    onMouseUp,
    ref: sliderRef
  };
};
export default useHorizontalSlider;